import { format, parseISO } from 'date-fns';

export const formatDate = (
  dateString: string | null | undefined,
  formatString: string = 'dd.MM.yyyy',
) => {
  if (!dateString) return '';
  try {
    const date = parseISO(dateString);
    return format(date, formatString);
  } catch {
    return dateString;
  }
};
